export const siteMeta = {
  name: '黑料六点',
  column: '黑料六点档',
  slogan: '每天 18:00，把一件复杂的事，整理成你三分钟能读完的样子。',
  updateText: '每日 18:00 更新',
  todayCount: '06',
  onlineCount: '1,284',
  archiveCount: '312',
};

export const navItems = [
  { label: '今日六点档', href: '#today' },
  { label: '栏目目录', href: '#columns' },
  { label: '话题墙', href: '#tags' },
  { label: '专题整理', href: '#topics' },
  { label: '网友反应', href: '#reactions' },
  { label: '脉络拆解', href: '#threads' },
];

export const tickerItems = [
  '黑料六点固定栏目 · 今日专题：联名风波完整时间线',
  '黑料六点每日栏目 · 投稿通道已开启',
  '关系图谱已更新至第 14 版',
  '网友反应：评论区已经分成三个阵营',
  '往期归档新增 12 条完整事件',
  '黑料六点档 · 每日 18:00 准时归档',
];

export const heroLead = {
  tag: '今日头条 · 六点档',
  title: '一句玩笑引爆的联名风波：从 12:07 到 18:00 的完整时间线',
  summary:
    '我们把这半天的公开对话、投稿截图与网友反应压进同一条：谁先开口、谁在回应、话题是在第几分钟拐弯的，一次看清。',
  meta: ['专题时长 3 分钟', '关联人物 7 位', '投稿截图 12 张'],
  image:
    'https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20lay%20of%20torn%20paper%20notes%20and%20speech%20bubble%20cutouts%20connected%20by%20red%20thread%20on%20beige%20desk%2C%20soft%20shadows%2C%20muted%20vermillion%20and%20amber%20accents%2C%20abstract%20storytelling%20composition&width=1200&height=800&seq=hl6-hero-lead-01&orientation=landscape',
};

export const heroSideCards = [
  {
    tag: '关系图谱',
    title: '三人同框的那一刻，时间其实对不上',
    meta: '更新于 14:20',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20beige%20background%20with%20geometric%20timeline%20nodes%20connected%20by%20thin%20vermillion%20lines%2C%20minimalist%20editorial%20infographic%20texture%2C%20soft%20paper%20grain&width=600&height=600&seq=hl6-hero-side-01&orientation=squarish',
  },
  {
    tag: '投稿截图',
    title: '聊天记录里的第 7 分钟，被人截了下来',
    meta: '今日投稿 3 条',
    image:
      'https://readdy.ai/api/search-image?query=stack%20of%20printed%20chat%20screenshots%20with%20blurred%20text%20blocks%20on%20warm%20beige%20paper%2C%20abstract%20editorial%20flat%20lay%2C%20soft%20natural%20light%2C%20amber%20and%20grey%20tones&width=600&height=600&seq=hl6-hero-side-02&orientation=squarish',
  },
  {
    tag: '网友反应',
    title: '评论区已经自动分成了三个阵营',
    meta: '热评 268 条',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20crowd%20of%20blurred%20speech%20bubbles%20in%20warm%20beige%20and%20soft%20red%2C%20minimalist%20editorial%20collage%2C%20paper%20texture%2C%20ample%20negative%20space&width=600&height=600&seq=hl6-hero-side-03&orientation=squarish',
  },
];

export const columnEntries = [
  {
    icon: 'ri-calendar-check-line',
    title: '今日六点档',
    desc: '每天 18:00 准时的一条完整整理',
    action: '进入今日',
    href: '#today',
    primary: true,
  },
  {
    icon: 'ri-folder-open-line',
    title: '栏目目录',
    desc: '按专题找对应事件，不用东拼西凑',
    action: '浏览目录',
    href: '#topics',
    primary: false,
  },
  {
    icon: 'ri-inbox-archive-line',
    title: '往期归档',
    desc: '全部已整理事件，按日期排好',
    action: '查看归档',
    href: '#topics',
    primary: false,
  },
  {
    icon: 'ri-upload-2-line',
    title: '投稿入口',
    desc: '把你知道的截图与线索交给我们',
    action: '立即投稿',
    href: '#submit',
    primary: false,
  },
];

export const tagWall = [
  { label: '时间线梳理', count: 42, hot: true },
  { label: '关系图谱', count: 36, hot: false },
  { label: '投稿截图', count: 28, hot: true },
  { label: '网友反应', count: 24, hot: false },
  { label: '对话还原', count: 19, hot: false },
  { label: '联名风波', count: 17, hot: true },
  { label: '同框细节', count: 14, hot: false },
  { label: '综艺花絮', count: 12, hot: false },
  { label: '直播回放', count: 11, hot: false },
  { label: '旧照对比', count: 9, hot: false },
  { label: '品牌合作', count: 8, hot: false },
  { label: '评论分屏', count: 7, hot: false },
  { label: '删帖记录', count: 6, hot: false },
  { label: '行程重叠', count: 5, hot: false },
];

export const topics = [
  {
    id: 't1',
    category: '时间线',
    tag: '时间线梳理',
    title: '联名风波：从一句话到全网拆解',
    summary: '把公开的发言、转发与下架动作固定在同一个时间轴上，看清楚是哪一步让话题拐了弯。',
    meta: '收录 12 个节点 · 更新 18:00',
    image:
      'https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20lay%20of%20an%20open%20notebook%20with%20red%20string%20pinned%20connection%20map%2C%20beige%20paper%2C%20amber%20accent%2C%20editorial%20abstract%20composition&width=800&height=600&seq=hl6-topic-01&orientation=landscape',
  },
  {
    id: 't2',
    category: '关系',
    tag: '关系图谱',
    title: '同框三人组：谁先离场，谁留到最后',
    summary: '按公开行程与现场照片复原位置关系，把容易看错的两处时间点单独标了出来。',
    meta: '关系连线 9 条 · 更新 17:40',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20collage%20of%20torn%20magazine%20clippings%20on%20warm%20beige%20background%2C%20muted%20red%20and%20amber%20tones%2C%20soft%20shadows%2C%20editorial%20flat%20lay&width=800&height=600&seq=hl6-topic-02&orientation=landscape',
  },
  {
    id: 't3',
    category: '截图',
    tag: '投稿截图',
    title: '第 7 分钟的聊天记录，与公开说法对不上',
    summary: '三条投稿相互印证，我们在图上标出了时间戳位置，也保留了原始截图比例。',
    meta: '投稿 3 条 · 已交叉核对',
    image:
      'https://readdy.ai/api/search-image?query=minimal%20warm%20beige%20scene%20with%20a%20single%20red%20wax%20seal%20on%20folded%20paper%2C%20abstract%20editorial%20still%20life%2C%20soft%20daylight&width=800&height=600&seq=hl6-topic-03&orientation=landscape',
  },
  {
    id: 't4',
    category: '反应',
    tag: '网友反应',
    title: '评论区三阵营：站队、看戏与喊退钱',
    summary: '把高赞评论归成三类，同一类里的观点只保留最有代表性的一条，避免重复刷屏。',
    meta: '采样 500+ 条 · 更新 18:00',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20grid%20of%20blurred%20portrait%20polaroids%20on%20a%20beige%20surface%2C%20muted%20tones%2C%20editorial%20flat%20lay%20photography&width=800&height=600&seq=hl6-topic-04&orientation=landscape',
  },
  {
    id: 't5',
    category: '时间线',
    tag: '行程重叠',
    title: '两场活动之间的 40 分钟，被行程表串了起来',
    summary: '官方行程、现场路透与航班信息三线并排，重合的时段被单独拎出来讨论。',
    meta: '时间锚点 8 个 · 更新 16:20',
    image:
      'https://readdy.ai/api/search-image?query=warm%20paper%20texture%20with%20abstract%20timeline%20arrows%20and%20dots%2C%20vermillion%20and%20amber%20accents%2C%20minimalist%20infographic%20collage&width=800&height=600&seq=hl6-topic-05&orientation=landscape',
  },
  {
    id: 't6',
    category: '关系',
    tag: '同框细节',
    title: '一张旧照被翻出来，站位成了新的证据',
    summary: '旧照与近期同框放在一起对比，姿势、机位与服装细节被网友逐帧拆过一遍。',
    meta: '对比图 6 组 · 更新 15:10',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20stack%20of%20envelopes%20and%20note%20cards%20on%20a%20warm%20beige%20desk%2C%20soft%20daylight%2C%20muted%20editorial%20tones&width=800&height=600&seq=hl6-topic-06&orientation=landscape',
  },
];

export const topicFilters = ['全部', '时间线', '关系', '截图', '反应'];

export const reactions = [
  {
    tag: '热评 01',
    author: '边看边记的柠檬',
    text: '时间线一拉出来就清楚了，之前刷到的说法顺序完全是反的。',
    likes: '2.3k',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20beige%20chat%20bubble%20shapes%20in%20soft%20red%20and%20amber%2C%20minimalist%20editorial%20pattern%2C%20paper%20texture&width=400&height=400&seq=hl6-react-01&orientation=squarish',
  },
  {
    tag: '热评 02',
    author: '路过的第七排',
    text: '最服的是把投稿截图和公开说法并排放，谁改了说法一眼就看出来。',
    likes: '1.8k',
    image:
      'https://readdy.ai/api/search-image?query=minimal%20warm%20beige%20background%20with%20a%20single%20thumbs%20up%20outline%20in%20vermillion%2C%20abstract%20editorial%20icon%20poster&width=400&height=400&seq=hl6-react-02&orientation=squarish',
  },
  {
    tag: '热评 03',
    author: '不看热闹看细节',
    text: '关系图谱那段我反复看了三遍，原来同框的顺序一直被我记错了。',
    likes: '1.2k',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20beige%20grid%20of%20tiny%20blurred%20comment%20lines%2C%20soft%20red%20accents%2C%20minimalist%20editorial%20pattern&width=400&height=400&seq=hl6-react-03&orientation=squarish',
  },
  {
    tag: '热评 04',
    author: '深夜补课中',
    text: '终于不用在十几个帖子里来回翻了，一条栏目把源头都标好，舒服。',
    likes: '980',
    image:
      'https://readdy.ai/api/search-image?query=warm%20beige%20paper%20with%20three%20abstract%20colored%20bars%20in%20vermillion%20amber%20and%20olive%2C%20minimalist%20editorial%20chart%20collage&width=400&height=400&seq=hl6-react-04&orientation=squarish',
  },
];

export const threadSteps = [
  {
    no: '01',
    title: '先定时间锚点',
    desc: '把每个节点固定到具体时间，避免先后顺序被倒置或记混。',
  },
  {
    no: '02',
    title: '再连人物关系',
    desc: '谁与谁同框、谁在哪个节点出现，画成一张能一眼看懂的关系图。',
  },
  {
    no: '03',
    title: '补上对话原文',
    desc: '公开对话与投稿截图对照排列，逐条标注来源与时间戳。',
  },
  {
    no: '04',
    title: '最后收网友反应',
    desc: '把评论区的主要观点归成几类，立场分开，不混在一起说。',
  },
];

export const footerLinks = [
  { label: '今日六点档', href: '#today' },
  { label: '栏目目录', href: '#columns' },
  { label: '话题墙', href: '#tags' },
  { label: '专题整理', href: '#topics' },
  { label: '网友反应', href: '#reactions' },
  { label: '脉络拆解', href: '#threads' },
];